
import jwt_decode from "jwt-decode";
import { COOKIE_CLEAR_SUFFIX, COOKIE_OPTIONS_SUFFIX } from "./cookieConfig";
import store from "../store";
import EventBus from "./eventBus";

export const setRefreshToken = (token) => {
  document.cookie = `refreshToken=${token}; ${COOKIE_OPTIONS_SUFFIX}`;
};

export const setToken = (token) => {
  document.cookie = `accessToken=${token}; ${COOKIE_OPTIONS_SUFFIX}`;
};

export const getAccess = (value) => {
  let data = document.cookie.split(";");
  for (let i in data) {
    let eqPos = data[i].indexOf("=");
    if (eqPos > -1) {
      let key = data[i].substring(0, eqPos).trim();
      let val = data[i].substring(eqPos + 1).trim();
      if (key === value && val !== 'no-access') {
        return val;
      }
    }
  }
  return null;
};

export const getResumeuuid = () => {
  return store.getters["userVUEX/getResumeuuid"];
};

export const clearCookies = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    if (name != "hire3x_heera_notifications") {
			document.cookie = `${name}=; ${COOKIE_CLEAR_SUFFIX}`;
		}
  }
};

export const checkTokenExpiry = () => {
  let cookieToken = getAccess("accessToken");
  let decoded = jwt_decode(cookieToken);
  let expirationTime = decoded.exp * 1000;
  let currentTime = Math.floor(new Date().getTime());
  if (currentTime >= expirationTime) {
    return true;
  } else {
    return false;
  }
};

const checkForPanelLogin = () => {
  let recData = getAccess("recruitment");
  if (
    recData.userPermissions &&
    recData.userPermissions.isActive &&
    (recData.userPermissions.roles.includes("Panelist") ||
      recData.userPermissions.roles.includes("Recruiter + Panelist"))
  ) {
    return true
  }
  return false
};

export const getAccessProjects = () => {
  let projects = [];
  if (getAccess("recruitment")) {
    projects.push("recruitment");
  }
  if (getAccess("assessment")) {
    projects.push("assessment");
  }
  if (getAccess("training")) {
    projects.push("training");
  }
  if (getAccess("collegeDashboard")) {
    projects.push("collegeDashboard");
  }
  return projects;
};

export const getAccessProjectsData = () => {
  let arr = []
  getAccessProjects().map(obj => {
    arr.push(JSON.parse(getAccess(obj)))
  })
  return arr;
}

export const extractProfileData = (details, targetType) => {
  if (!details || !Array.isArray(details) || details.length === 0) { // 1. Safety Check: Returns empty strings if no details array exists
    return { image: "", username: "Guest User" };
  }

  let preferredProject = targetType;
  if (targetType === "admin") {
    preferredProject = localStorage.getItem("lastAdminProject") || "";
  }

  let matchedProj = null;

  // Helper: treat blank/whitespace-only strings as empty
  const hasName = (val) => !!(val && val.trim());
  const hasImage = (val) => !!(val && val.trim());

  // 1. Try exact match on target/preferred project (e.g. "candidate", "training", "recruitment", "assessment")
  if (preferredProject) {
    matchedProj = details.find(
      (p) => p.project === preferredProject && (hasImage(p.image) || hasName(p.displayName))
    );
  }

  // 2. If target is admin and no exact match on preferred project, find first active non-candidate project
  if (!matchedProj && targetType !== "candidate") {
    matchedProj = details.find(
      (p) => p.project !== "candidate" && (hasImage(p.image) || hasName(p.displayName))
    );
  }

  // 3. Fallback for candidate if target is candidate
  if (!matchedProj && targetType === "candidate") {
    matchedProj = details.find((p) => p.project === "candidate");
  }

  let foundImage = matchedProj && hasImage(matchedProj.image) ? matchedProj.image.trim() : "";
  let foundUsername = matchedProj && hasName(matchedProj.displayName) ? matchedProj.displayName.trim() : "";

  // 4. Ultimate fallback: loop through details for any non-empty image/displayName
  if (!foundImage || !foundUsername) {
    for (const proj of details) {
      if (!foundImage && hasImage(proj.image)) foundImage = proj.image.trim();
      if (!foundUsername && hasName(proj.displayName)) foundUsername = proj.displayName.trim();
    }
  }

  return {
    image: foundImage,
    username: foundUsername || "Guest User",
  };
};

export const checkIfLoggedIn = (isLaptop, redirectUrl, userType, hideBusiness = false) => {
  if (redirectUrl && userType === "candidate" && getAccess("candidate")) {
    window.location.href = redirectUrl;
    return;
  } else if (redirectUrl && userType === "candidate" && !getAccess("candidate")) {
    EventBus.$emit("open-login-modal", { redirectUrl, hideBusiness });
    return;
  }

  store.commit("userVUEX/setCollege", {});
  console.log(getResumeuuid())
  if (getResumeuuid() && getAccess("candidate")) {
    store.dispatch("userVUEX/goToPage", {
      project: "candidate",
      details: getAccessProjectsData(),
      loggedIn: true
    });
  }
  else if (getResumeuuid() && !getAccess("candidate")) EventBus.$emit("open-login-modal", { mode: 'login', userType: userType, hideBusiness });

  else if (userType === "admin") {
    if (!getAccess("assessment") && !getAccess("collegeDashboard") && !getAccess("recruitment") && !getAccess("training") && getAccess("candidate") || getAccessProjects().length == 0) {
      EventBus.$emit("open-login-modal", { mode: 'login', userType: userType, hideBusiness });
    }

    else if (!isLaptop && getAccessProjects().length == 1 && getAccessProjects()[0] === "recruitment" && checkForPanelLogin()) {
      store.dispatch("userVUEX/goToPage", {
        project: "recruitment",
        details: getAccessProjectsData(),
        loggedIn: true
      });
    }
    else {
      if (!isLaptop) {
        EventBus.$emit("open-login-modal", { mode: 'login', userType: userType, hideBusiness });
      } else {
        store.dispatch("userVUEX/goToPage", {
          project: "admin",
          details: getAccessProjectsData(),
          loggedIn: true
        });
      }
    }
  }

  else if (userType === "candidate" && getAccess("candidate")) {
    store.dispatch("userVUEX/goToPage", {
      project: "candidate",
      details: getAccessProjectsData(),
      loggedIn: true
    });
  }

  else {
    EventBus.$emit("open-login-modal", { mode: 'login', userType: userType, hideBusiness });
  }
};

export const openLoginModal = ({ mode = 'login', redirectUrl = null, userType = 'candidate', hideBusiness = false } = {}) => {
  const isLaptop = window.innerWidth > 1028;
  // If already logged in with a valid session, redirect instead of showing modal
  if (
    document.cookie.length != 0 &&
    getAccess("accessToken") &&
    getAccess("refreshToken") &&
    !checkTokenExpiry()
  ) {
    checkIfLoggedIn(isLaptop, redirectUrl, userType, hideBusiness);
    return;
  }
  mode = "login";
  // Not logged in — open the login modal via EventBus
  EventBus.$emit("open-login-modal", { mode, redirectUrl, userType, hideBusiness });
};

const getToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "accessToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const getRefreshToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "refreshToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const setLocalTokens = () => {
  localStorage.setItem("vue_token", getToken());
  localStorage.setItem("refresh_token", getRefreshToken());
};

export const checkAndSetAccess = () => {
  const hasAccess = ["candidate", "training", "recruitment", "collegeDashboard", "assessment"].some(type => getAccess(type));
  let val = hasAccess && getToken() ? true : false;
  store.commit("userVUEX/setCandAccess", val);
  setLocalTokens();
}

// Guest UUID management for anonymous search history
export const getGuestUUID = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "guest_uuid") {
        return cur[1];
      }
    }
  }

  return null;
};

export const setGuestUUID = (uuid) => {
  document.cookie = `guest_uuid=${uuid}; ${COOKIE_OPTIONS_SUFFIX}`;
};

export const ensureGuestUUID = () => {
  let uuid = getGuestUUID();
  if (!uuid) {
    uuid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
    setGuestUUID(uuid);
  }
  return uuid;
};

export const clearGuestUUID = () => {
  document.cookie = `guest_uuid=; ${COOKIE_CLEAR_SUFFIX}`;
};

export const clearAllCookiesExceptGuest = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    
    // Skip guest_uuid
    if (name === "guest_uuid" || name === "hire3x_heera_notifications") continue;

    document.cookie = `${name}=; ${COOKIE_CLEAR_SUFFIX}`;
  }
};


